import { useSelector } from '@lingoda/hooks';
import { useConfigurationSuspenseQuery } from '@lingoda/monolith-graphql';
import { paymentMethodsStoredSelector } from '../selectors';

type MaxPaymentMethodsResult =
    | { isEnabled: true; maxPaymentMethods: number; isLimitReached: boolean }
    | { isEnabled: false; maxPaymentMethods: undefined; isLimitReached: false };

export const useMaxPaymentMethods = (): MaxPaymentMethodsResult => {
    const { data } = useConfigurationSuspenseQuery();
    const paymentMethodsStored = useSelector(paymentMethodsStoredSelector);

    const {
        isMaxActivePaymentMethodsEnabled: isEnabled,
        maxActivePaymentMethods: maxPaymentMethods,
    } = data.config;

    if (!isEnabled) {
        return { isEnabled: false, maxPaymentMethods: undefined, isLimitReached: false };
    }

    return {
        isEnabled: true,
        maxPaymentMethods,
        isLimitReached: paymentMethodsStored.length >= maxPaymentMethods,
    };
};
